module.exports = __webpack_public_path__ + "img/image-24.fcb7fee4.jpg";